var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M16 22.040c-0.334 0-0.67-0.112-0.946-0.336l-9.536-7.75c-0.642-0.524-0.74-1.468-0.218-2.112 0.522-0.642 1.466-0.74 2.11-0.218l8.584 6.976 8.468-6.97c0.636-0.524 1.584-0.434 2.112 0.206s0.436 1.584-0.206 2.112l-9.416 7.75c-0.276 0.228-0.614 0.342-0.952 0.342z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon-arrow-down.b33e6d61.svg";
export { ForwardRef as ReactComponent };